export default __webpack_public_path__ + "static/media/instacart-color.adf8220b.svg";